import { InternalTransferPrintPage } from '@/features/internal-transfer/pages/InternalTransferPrintPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/internal-transfer/$id/print')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["internal_transfer.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: InternalTransferPrintPage,
})
